export default "__VITE_ASSET__D6r8A6_m__"